import React,{useContext} from "react";
import { Row, Col, Container } from "react-bootstrap";
import { DownloadSvg,CarGosvg,EasyBookingSvg } from "./HomeSvg";
import { LanguageContext } from "../context/LanguageContext";
const HowItWorks = () => {
    const { translations } = useContext(LanguageContext);
  return (
    <div className="padding_cmn how_itWork">
      <Container>
        <h6 className="rm_subheading text-center">
       {translations.HowItWorks?.subTitle}
        </h6>
        <h2 className="text-center subTitle" dangerouslySetInnerHTML={{ __html: translations.HowItWorks?.title }}>
        </h2>
        <Row className="pt-4">
            <Col lg={4}>
            <div className="work_grid text-center">
                {DownloadSvg}
                <h4 className="text-center">{translations.HowItWorks?.workProcess?.downloadApp}</h4>
                <p className="text-center">{translations.HowItWorks?.workProcess?.downloadAppText}</p>
            </div>
            </Col>
            <Col lg={4}>
            <div className="work_grid text-center">
                {EasyBookingSvg}
                <h4 className="text-center">{translations.HowItWorks?.workProcess?.choose}</h4>
                <p className="text-center">{translations.HowItWorks?.workProcess?.chooseText}</p>
            </div>
            </Col>
            <Col lg={4}>
            <div className="work_grid text-center">
                {CarGosvg}
                <h4 className="text-center">{translations.HowItWorks?.workProcess?.confirm}</h4>
                <p className="text-center">{translations.HowItWorks?.workProcess?.confirmText}</p>
            </div>
            </Col>
        </Row>
      </Container>
    </div>
  );
};

export default HowItWorks;
